import { useEffect, useState } from 'react';

type UseTabActivityOptions = {
  onFocus?: () => void;
  onBlur?: () => void;
};

export function useTabActivity({ onFocus, onBlur }: UseTabActivityOptions) {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const handleFocus = () => {
      setIsActive(true);
      onFocus?.();
    };

    const handleBlur = () => {
      setIsActive(false);
      onBlur?.();
    };

    const handleVisibilityChange = () => {
      const visible = document.visibilityState === 'visible';
      setIsActive(visible);
      if (visible) {
        onFocus?.();
      } else {
        onBlur?.();
      }
    };

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onFocus, onBlur]);

  return isActive;
}
